import { Music, Play } from "lucide-react";

import { cn } from "~/shared/lib/utils";

interface MediaThumbProps {
    url: string;
    /** "video" рендерит постер первого кадра, audio — компактный аудио-тайл. */
    kind: string | null;
    className?: string;
}

/**
 * Превью медиа: <img> для изображения, постер первого кадра видео через Media Fragment
 * URI `#t=0.1` (без серверного poster/canvas — см. feedback_video_thumbnail_media_fragment).
 * Общий рендер для превью-ячеек и карточек (ассеты, генерации).
 */
export function MediaThumb({ url, kind, className }: MediaThumbProps) {
    if (kind === "video") {
        return (
            <div className={cn("relative size-full bg-muted", className)}>
                <video
                    src={`${url}#t=0.1`}
                    preload="metadata"
                    muted
                    playsInline
                    className="absolute inset-0 size-full object-cover"
                />
                <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                    <span className="flex size-9 items-center justify-center rounded-full bg-black/55 text-white backdrop-blur">
                        <Play className="size-4" aria-hidden />
                    </span>
                </div>
            </div>
        );
    }

    if (kind === "audio") {
        return (
            <div
                className={cn(
                    "flex size-full items-center justify-center bg-muted text-violet-300",
                    className,
                )}
            >
                <Music className="size-8" aria-hidden />
            </div>
        );
    }

    return <img src={url} alt="" loading="lazy" className={cn("size-full object-cover", className)} />;
}
